import React, { useState } from "react";
import { StyleSheet, Image, Text, View, SafeAreaView } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { TouchableOpacity } from "react-native-gesture-handler";
import Svg, { Path } from "react-native-svg";

export default function WavyHeader({ customStyles }) {
  return (
    <View style={customStyles}>
      <View>
        <Image source={require("../img/bg.jpg")} style={styles.img} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
    img:{
        zIndex: -1
    }
})
